/**
 *
 *  useButtonsHidden
 *  TruBe Date Time hook
 *
 *  Created by Vladimir Shishlyannikov on 24/02/2023.
 *  Copyright (c) 2016-present iWoo Ltd. All rights reserved.
 *
 */

import { useCallback, useEffect, useState } from "react";

// import useTruthy from "../useTruthy/useTruthy";

export default function useButtonsHidden({
  contentScrollerApi,
  itemCount,
  isLoading,
}) {
  const s = "wide",
    // f = useTruthy(itemCount),
    lastItemKey = itemCount - 1,
    [hiddenPrev, setHiddenPrev] = useState(true),
    [hiddenNext, setHiddenNext] = useState(false);

  const stateChangeHandler = useCallback(
    ({ reason, elementStateByIndex }, newState) => {
      if (reason === "reset" || newState == null) {
        return;
      }

      const [elState, newElState] = [
        elementStateByIndex.get(1),
        newState.elementStateByIndex.get(1),
      ];

      if (elState !== newElState) {
        setHiddenPrev(!!elState);
      }

      const [lastElState, newLastElState] = [
        elementStateByIndex.get(lastItemKey),
        newState.elementStateByIndex.get(lastItemKey),
      ];

      if (lastElState !== newLastElState) {
        setHiddenNext(!!lastElState);
      }
    },
    [lastItemKey]
  );

  const visible =
    contentScrollerApi == null
      ? null
      : isLoading
      ? null
      : contentScrollerApi.getVisibleItemIndexes();

  useEffect(() => {
    if (s !== "wide") {
      return;
    }

    if (visible == null || contentScrollerApi == null) {
      return;
    }

    let clean;

    if (visible.length) {
      setHiddenPrev(visible.includes(1));
      setHiddenNext(visible.includes(lastItemKey));
    }

    let mounted = true;

    setTimeout(() => {
      if (mounted) {
        const prevStateChangeHandler = contentScrollerApi.addStateChangeHandler(
            1,
            {
              handler: stateChangeHandler,
            }
          ),
          nextStateChangeHandler =
            contentScrollerApi == null
              ? undefined
              : contentScrollerApi.addStateChangeHandler(lastItemKey, {
                  handler: stateChangeHandler,
                });

        clean = () => {
          prevStateChangeHandler();
          nextStateChangeHandler();
        };
      }
    });

    return () => {
      mounted = false;

      if (clean) {
        clean();
      }
    };
  }, [
    visible,
    itemCount,
    s,
    contentScrollerApi,
    lastItemKey,
    stateChangeHandler,
  ]);

  return [hiddenPrev, hiddenNext];
}
